export default "__VITE_ASSET__DnlFb0jr__"